import { css, styled } from '@mui/material';

import { PALETTE } from '../../../../theme/palette';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledUploadButtonContainer = styled('div')(
  ({ theme }) => css`
    width: fit-content;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;

    > button,
    > img {
      margin-right: ${theme.spacing('LARGE')};
    }

    ${theme.breakpoints.up('desktop')} {
      > button {
        width: 72px;
        height: 72px;
      }
    }
  `
);

export const StyledFileItem = styled('div')(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${theme.spacing('LARGE')};
    padding-top: ${theme.spacing('LARGE')};
    border-top: 1px solid ${theme.palette.gray.light_gray};
    word-break: break-word;
    column-gap: ${theme.spacing('LARGE')};

    &:first-of-type {
      margin-top: 0;
      padding-top: 0;
      border-top: none;
    }
  `
);

export const StyledUploadDocumentHintContainer = styled('div')`
  display: flex;
`;

export const StyledUploadDocumentHintMainInformationContainer = styled('div')(
  ({ theme }) => css`
    width: 100%;

    ${theme.breakpoints.up('desktop')} {
      width: 50%;
    }
  `
);

export const StyledUploadDocumentHintsListOuterContainer = styled('div')`
  display: flex;
`;

export const StyledUploadDocumentHintsListInnerContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing('SMALL')};
    row-gap: ${theme.spacing('SMALL')};
  `
);

export const StyledUploadDocumentHintDesktopIllustrationContainer = styled('div')(
  ({ theme }) => css`
    display: none;
    width: 50%;
    align-self: center;
    text-align: center;

    svg {
      width: 60%;
      height: 60%;
    }

    ${theme.breakpoints.up('desktop')} {
      display: block;
    }
  `
);

export const StyledUploadDocumentHintMobileIllustrationContainer = styled('div')(
  ({ theme }) => css`
    display: block;
    flex-grow: 1;
    margin-top: ${theme.spacing('SMALL')};

    svg {
      width: auto;
      height: auto;
    }

    ${theme.breakpoints.up('desktop')} {
      display: none;
    }
  `
);

export const StyledUploadDocumentHintsList = styled('div')`
  display: flex;
`;

export const StyledUploadDocumentsHintBadStuffTitle = styled('div')(
  ({ theme }) => css`
    margin-top: ${theme.spacing('LARGE')};
  `
);

export const StyledFileUploadTipContainer = styled('div')(
  ({ theme }) => css`
    background: ${theme.palette.background.info};
    padding: ${theme.spacing('LARGE')};
    border-radius: 2px;
  `
);

export const StyledVitoloAdditionalFilesTipContainer = styled('div')(
  ({ theme }) => css`
    background: ${PALETTE.ULTRA_LIGHT_PEACH};
    border-radius: 2px;
    margin-top: ${theme.spacing('LARGE')};
    padding: ${theme.spacing('LARGE')};
  `
);
